module.exports = __webpack_public_path__ + "img/xaas-cloud.651e722.png";